import { NavLink } from 'react-router-dom';

import { useAuth } from '../context/AuthContext.jsx';

// The top-of-sidebar dashboard tabs. Shown wherever a user has access to more
// than one dashboard: XM (xm roles), Sentiment + Upgrade Weekend (marketing
// roles); super_admin sees all three. Hidden when only one tab applies.
export default function DashboardSwitcher() {
  const { isAdmin, isMarketing } = useAuth();
  const tabs = [];
  if (isAdmin()) tabs.push({ to: '/dashboard', label: 'XM Dashboard' });
  if (isMarketing()) {
    tabs.push({ to: '/sentiment', label: 'Sentiment' });
    tabs.push({ to: '/analytics', label: 'Upgrade Web Analytics' });
  }
  if (tabs.length < 2) return null;

  return (
    <nav className="sidebar__switcher" aria-label="Dashboard switcher">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end
          className={({ isActive }) =>
            'sidebar__link' + (isActive ? ' sidebar__link--active' : '')
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
